import { FormSchema } from './types';

export type PrefillContext = Record<string, unknown>;
type FieldRule = { match: string; value: unknown };

const FILLABLE_TYPES = new Set(['text', 'number', 'email', 'tel', 'url', 'textarea', 'select', 'radio', 'hidden']);

/**
 * Fills the form's fixed fields from `context.fieldRules`: each rule is a case-insensitive regex
 * tested against field labels. A rule fills at most one field (the first match in form order) and
 * a field takes at most one rule (the first, so list the most specific rule first). Nothing here
 * is stored in the schema.
 */
export function buildPrefill(schema: FormSchema, context?: PrefillContext): Record<string, unknown> {
  const values: Record<string, unknown> = {};
  const rules = (context?.fieldRules as FieldRule[] | undefined) || [];
  if (!rules.length) return values;

  const compiled = rules.flatMap((rule) => {
    try { return [{ regex: new RegExp(rule.match, 'i'), value: rule.value }]; } catch { return []; }
  });
  const usedRules = new Set<number>();

  schema.steps.forEach((step) => step.fields.forEach((field) => {
    if (!FILLABLE_TYPES.has(field.type)) return;
    const label = field.label || '';
    const index = compiled.findIndex((rule, i) => !usedRules.has(i) && rule.regex.test(label));
    if (index < 0) return;
    usedRules.add(index);
    values[field.key] = compiled[index].value;
  }));
  return values;
}
